import {
  Calendar, Settings, Users, FileText, Ticket, BarChart3,
  ChevronRight, MapPin, CalendarPlus, CalendarClock, Wallet, Receipt, Zap,
  Package, Home, Radio, Flame, Bike, ShieldAlert, Lightbulb, FolderOpen, CreditCard, QrCode, Building2,
  ClipboardList, AlertTriangle, ArrowRightLeft, Shield, Clock, Euro, MessageCircle, Camera, ScanLine, Bell, Bot, Award
} from 'lucide-react';

export const buildMenuItems = (currentUser, userPermissions, appSettings) => {
  const allMenuItems = [
    { group: 'operations', icon: Calendar, label: 'Καθημερινές Λειτουργίες', color: 'text-blue-600', children: [
      { icon: CalendarPlus, label: 'Κρατήσεις Θέσεων', path: '/reservations', color: 'text-green-600' },
      { icon: Calendar, label: 'Μηνιαίες Ενοικιάσεις', path: '/rentals', color: 'text-blue-600' },
      { icon: Ticket, label: 'Προπληρωμένα Εισιτήρια', path: '/tickets', color: 'text-purple-600' },
      { icon: Users, label: 'Πελάτες', path: '/customers', color: 'text-green-600' },
      // Phase 6.14 (v1.0.9.47) — user-facing loyalty lookup (non-admin can access)
      { icon: Award, label: 'Πιστότητα Πελατών', path: '/loyalty-lookup', color: 'text-yellow-500' },
      { icon: Award, label: 'Πρόγραμμα Πιστότητας', path: '/loyalty', color: 'text-amber-500', adminOnly: true },
      { icon: AlertTriangle, label: 'Αναφορά Συμβάντων', path: '/incidents', color: 'text-red-600' },
      { icon: Bell, label: 'Υπενθυμίσεις Πελατών', path: '/reminders', color: 'text-amber-500', adminOnly: true },
      { icon: Wallet, label: 'Διαχείριση Ταμείου', path: '/cash-register', color: 'text-emerald-600' },
      { icon: FileText, label: 'Ημερήσιες Αναφορές', path: '/reports', color: 'text-orange-600', permKey: 'reports' },
    ]},
    { group: 'finance', icon: BarChart3, label: 'Οικονομικά', color: 'text-amber-600', adminOnly: true, children: [
      { icon: BarChart3, label: 'Αναλυτικά Στατιστικά', path: '/statistics', color: 'text-indigo-600' },
      { icon: Receipt, label: 'Έσοδα/Έξοδα Παραστατικά', path: '/expenses-advanced', color: 'text-amber-600' },
      { icon: FolderOpen, label: 'Λογιστικός Φάκελος', path: '/accountant-folder', color: 'text-[#004C98]' },
      { icon: Building2, label: 'Συνεργαζόμενες Επιχ.', path: '/partner-businesses', color: 'text-violet-600' },
      { icon: CreditCard, label: 'POS & Epsilon Smart', path: '/pos-epsilon', color: 'text-violet-600' },
      ...(appSettings?.z_report_enabled ? [{ icon: BarChart3, label: 'Z-Report Ημέρας', path: '/z-report', color: 'text-emerald-600' }] : []),
    ]},
    { group: 'staff', icon: Users, label: 'Προσωπικό', color: 'text-indigo-600', adminOnly: true, children: [
      { icon: Users, label: 'Διαχείριση Προσωπικού', path: '/staff', color: 'text-indigo-600' },
      { icon: CalendarClock, label: 'Πρόγραμμα Εργασίας', path: '/scheduling', color: 'text-violet-600' },
      { icon: Clock, label: 'ΕΡΓΑΝΗ Παρουσίες', path: '/ergani', color: 'text-teal-600' },
      { icon: ArrowRightLeft, label: 'Αλλαγή Βάρδιας', path: '/shift-handover', color: 'text-teal-600' },
      { icon: Euro, label: 'Μισθοδοσία', path: '/payroll', color: 'text-green-700' },
      { icon: Shield, label: 'Ασφάλιση Προσωπικού', path: '/insurance', color: 'text-blue-700' },
    ]},
    { group: 'infra', icon: Package, label: 'Υποδομές Parking', color: 'text-orange-600', adminOnly: true, children: [
      { icon: MapPin, label: 'Πληρότητα & Κάμερες', path: '/occupancy', color: 'text-red-600' },
      { icon: Package, label: 'Εξοπλισμός', path: '/equipment', color: 'text-orange-600' },
      { icon: Zap, label: 'Φορτίσεις EV', path: '/ev-charging', color: 'text-emerald-500' },
      { icon: Bike, label: 'Micromobility', path: '/micromobility', color: 'text-teal-600' },
    ]},
    { group: 'iot', icon: Radio, label: 'IoT & Ασφάλεια', color: 'text-cyan-600', adminOnly: true, children: [
      { icon: Home, label: 'Smart Home', path: '/smart-home', color: 'text-blue-600' },
      { icon: Camera, label: 'ReoLink Cameras', path: '/reolink', color: 'text-indigo-600' },
      { icon: ScanLine, label: 'Αναγνώριση Πινακίδων', path: '/plate-recognition', color: 'text-violet-600' },
      { icon: Radio, label: 'Αισθητήρες Εδάφους', path: '/ground-sensors', color: 'text-cyan-600' },
      { icon: Flame, label: 'Πυρασφάλεια', path: '/fire-safety', color: 'text-red-600' },
      { icon: ShieldAlert, label: 'Συναγερμός', path: '/alarm-system', color: 'text-red-700' },
      { icon: Lightbulb, label: 'Ηλεκτρικά & Φωτισμός', path: '/electrical', color: 'text-amber-500' },
    ]},
    { icon: Shield, label: 'Κρατικοί Έλεγχοι', path: '/tax-report', color: 'text-red-700', permKey: 'settings', adminOnly: true },
    { group: 'logs', icon: FileText, label: 'Ιστορικά & Logs', color: 'text-slate-500', adminOnly: true, children: [
      { icon: FileText, label: 'Ιστορικό Μπάρας', action: 'barrierLogs', color: 'text-slate-600' },
      { icon: Users, label: 'Ιστορικό Συνδέσεων', action: 'loginLogs', color: 'text-slate-600' },
      { icon: FileText, label: 'Ιστορικό Ενεργειών', path: '/audit-logs', color: 'text-slate-600' },
    ]},
    { icon: Settings, label: 'Ρυθμίσεις', path: '/settings', color: 'text-slate-600', permKey: 'settings', adminOnly: true },
    { icon: MessageCircle, label: 'Υποστηριξη', path: '/support', color: 'text-green-600', permKey: 'support', adminOnly: true },
    { icon: Bot, label: 'AI Reviewer', path: '/ai-reviewer', color: 'text-amber-400', adminOnly: true },
    { icon: QrCode, label: 'Terminal Σαρωσης', path: '/terminal', color: 'text-amber-500', permKey: 'terminal' },
  ];

  const filtered = allMenuItems.filter(item => {
    if (currentUser?.role === 'admin') return true;
    if (item.adminOnly) return false;
    return userPermissions?.[item.permKey] !== false;
  });

  if (currentUser?.role !== 'admin') {
    const flat = [];
    for (const item of filtered) {
      if (item.group && item.children) {
        for (const child of item.children) {
          if (child.path) {
            if (child.permKey) {
              const perm = userPermissions?.[child.permKey];
              if (child.permKey === 'reports' && perm !== true) continue;
              if (child.permKey !== 'reports' && perm === false) continue;
            }
            flat.push(child);
          }
        }
      } else flat.push(item);
    }
    return flat;
  }
  return filtered;
};
